import $ from 'jquery';
import config from '../../../config';

// Get Employee
export function save_expense( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'expense/',
			data: {
                method: 'SAVE_EXPENSE',
                data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "SAVE_EXPENSE",
				expense: response
			})
		})

	}
}

export function get_users(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'expense/',
			data: {
                method: 'EXP_GET_USERS',
            }
		})
		.then(function (response) {
			dispatch({
				type: "EXP_GET_USERS",
				expense: response
			})
		})

	}
}

export function get_expense( users ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'expense/',
			data: {
                method: 'GET_EXPENSE',
                users: users
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_EXPENSE",
				expense: response
			})
		})

	}
}

export function delete_expense( expense_id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'expense/',
			data: {
                method: 'DELETE_EXPENSE',
                expense_id: expense_id
            }
		})
		.then(function (response) {
			dispatch({
				type: "DELETE_EXPENSE",
				expense: response
			})
		})

	}
}

export function update_expense( id, key, value ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'expense/',
			data: {
                method: 'UPDATE_EXPENSE',
                id: id,
                key: key,
                value: value
            }
		})
		.then(function (response) {
			dispatch({
				type: "UPDATE_EXPENSE",
				expense: response
			})
		})

	}
}




// WEBPACK FOOTER //
// ./src/pages/expense/actions/expense.action.js